import React from "react";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";
import CreatableSelect from 'react-select/creatable';
import "./PhoneBookElements.css";
import moment from "moment";
import ButtonSpeechBubble from "../AscElements/SetButtonWithSpeechBubble";
import {faPlay, faMinus} from "@fortawesome/free-solid-svg-icons";


/**
 * 要約詳細(電話帳)名入力アイテム
 * state.nameが必要
 */
export class EditPhoneBookName extends Component {
    render() {
        return (
            <InlineForm
                key = "phonebook_name"
                controlId = "phonebook_name"
                label = {this.props.langText.Body.Name}
                type = "text"
                value = {this.props.state.name}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "name", this.props.charaLimit.PhoneBook.name)}
                validationstate = {this.props.state.name ? null : "error"} />
        );
    }
}

/**
 * 要約詳細(電話帳)名表示アイテム
 * state.nameが必要
 */
export class ViewPhoneBookName extends Component {
    render() {
        return (
            <InlineForm
                key = "phonebook_name"
                controlId = "phonebook_name"
                label = {this.props.langText.Body.Name}
                type = "text"
                value = {this.props.state.name}
                readOnly
            />
        )
    }
}

/**
 * 要約詳細(電話帳)相手先番号入力アイテム
 * state.external_numberが必要
 */
export class EditPhoneBookExternalNum extends Component {
    render(){
        const hasInvalid = this.props.state.external_number_invalids && this.props.state.external_number_invalids.length > 0;
        return(
            <InlineForm
                key = "phonebook_external_number"
                controlId = "phonebook_external_number"
                label = {this.props.langText.Body.DestTelNumber}
            >
                <div className={hasInvalid ? "is-invalid" : undefined}>
                    <CreatableSelect
                        isMulti
                        onChange = {e => this.props.onMultiSelectChange_External(e)}
                        placeholder = {this.props.langText.Message.Validation_ExternalTelno || this.props.langText.Message.Validation_Telno}
                        isClearable
                        isSearchable
                        backspaceRemovesValue={true}
                        value={this.props.state.external_number}
                        noOptionsMessage={() => null}
                        classNamePrefix="ext"
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null
                        }}
                    />
                </div>
            </InlineForm>
        )
    }
}

/**
 * 要約詳細(電話帳)相手先番号表示アイテム
 * state.external_numberが必要
 */
export class ViewPhoneBookExternalNum extends Component {
    render(){
        let str = "";
        if (this.props.state.external_number && this.props.state.external_number.length) {
            this.props.state.external_number.forEach(row => {
                str += row.value + ", "
            });
            str = str.slice(0,str.length - 2);
        } else {
            str = "---";
        }
        return(
            <InlineForm
                key = "phonebook_external_number"
                controlId = "phonebook_external_number"
                label = {this.props.langText.Body.DestTelNumber}>
                {str}
            </InlineForm>
        )
    }
}

/**
 * 要約詳細(電話帳)メモ入力アイテム
 * state.memoが必要
 */
export class EditPhoneBookMemo extends Component {
    render() {
        return (
            <InlineForm
                key = "phonebook_memo"
                controlId = "phonebook_memo"
                label = {this.props.langText.Body.Memo}
                as = "textarea"
                rows = {3}
                value = {this.props.state.memo}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "memo", this.props.charaLimit.PhoneBook.memo)}
                validationstate = {this.props.state.memo ? null : "error"} />
        );
    }
}

/**
 * 要約詳細(電話帳)メモ表示アイテム
 * state.memoが必要
 */
export class ViewPhoneBookMemo extends Component {
    render() {
        return (
            <InlineForm
                key = "phonebook_memo"
                controlId = "phonebook_memo"
                label = {this.props.langText.Body.Memo}
                as = "textarea"
                rows = {3}
                value = {this.props.state.memo}
                readOnly
            />
        );
    }
}

/**
 * 要約詳細(電話帳)外線番号表示アイテム
 * state.external_numberが必要
 */
export class ViewPhoneBookExistingExternalNum extends Component {
    render(){
        let elements = [];
        if (this.props.state.existing_external_number && this.props.state.existing_external_number.length) {
            // 重複した番号を除去
            const uniqueNumbers = [];
            const seenNumbers = new Set();
            
            this.props.state.existing_external_number.forEach(row => {
                if (!seenNumbers.has(row.value)) {
                    seenNumbers.add(row.value);
                    uniqueNumbers.push(row);
                }
            });
            
            uniqueNumbers.forEach((row, index) => {
                // 複数の重複番号をチェック
                const duplicateNumbers = this.props.state.duplicate_phonebook_external_numbers || 
                                       [this.props.state.duplicate_phonebook_external_number];
                const isDuplicated = duplicateNumbers.includes(row.value);
                
                elements.push(
                    <span 
                        key={index}
                        className={isDuplicated ? "phonebook-duplicated-number" : "phonebook-normal-number"}
                    >
                        {row.value}
                    </span>
                );
                
                // 最後の要素でない場合はカンマを追加
                if (index < uniqueNumbers.length - 1) {
                    elements.push(<span key={`comma-${index}`}>, </span>);
                }
            });
        } else {
            elements.push(<span key="no-data">---</span>);
        }
        
        // 重複番号のメッセージを生成
        const duplicateNumbers = this.props.state.duplicate_phonebook_external_numbers || 
                               [this.props.state.duplicate_phonebook_external_number];
        const duplicateNumbersText = duplicateNumbers.filter(num => num).join(', ');
        
        //会社名
        return(
            <>
                <p className="phonebook-confirm-message">{this.sprintf(this.props.langText.Message.PhoneBook_Unify_Confirm_Message, 
                        duplicateNumbersText, this.props.state.company_name)}</p>
                <InlineForm
                    key = "phonebook_existing_external_number"
                    controlId = "phonebook_existing_external_number"
                    label = {`"${this.props.state.company_name}"${this.props.langText.Body.Of}${this.props.langText.Body.PhoneBook}`}>
                    {elements}
                </InlineForm>
            </>
        )
    }
}

/**
 * 要約詳細(電話帳)外線番号表示アイテム
 * state.external_numberが必要
 */
export class ViewPhoneBookNewExternalNum extends Component {
    render(){
        let elements = [];
        if (this.props.state.external_number && this.props.state.external_number.length) {
            this.props.state.external_number.forEach((row, index) => {
                // 複数の重複番号をチェック
                const duplicateNumbers = this.props.state.duplicate_phonebook_external_numbers || 
                                       [this.props.state.duplicate_phonebook_external_number];
                const isDuplicated = duplicateNumbers.includes(row.value);
                
                elements.push(
                    <span 
                        key={index}
                        className={isDuplicated ? "phonebook-duplicated-number" : "phonebook-normal-number"}
                    >
                        {row.value}
                    </span>
                );
                
                // 最後の要素でない場合はカンマを追加
                if (index < this.props.state.external_number.length - 1) {
                    elements.push(<span key={`comma-${index}`}>, </span>);
                }
            });
        } else {
            elements.push(<span key="no-data">---</span>);
        }
        
        return(
            <>
                <InlineForm
                    key = "phonebook_external_number"
                    controlId = "phonebook_external_number"
                    label = {`${this.props.langText.Body.Present}${this.props.langText.Body.Of}${this.props.langText.Body.PhoneBook}`}>
                    {elements}
                </InlineForm>
                <p key = "phonebook_external_number_duplicated" className="text-danger phonebook-duplicated-message">
                    {this.props.langText.Message.PhoneBook_External_Number_Duplicated[0]}
                </p>
                <p key = "phonebook_external_number_duplicated" className="text-danger">
                    {this.props.langText.Message.PhoneBook_External_Number_Duplicated[1]}
                </p>
            </>
        )
    }
}


/**
 * 
 * 削除項目ビューアイテム
 * state.selectedDataが必要
 */
export class ViewCallHistoryList extends Component {
    render(){
        const callHistories = this.props.state.selectedData && 
                            this.props.state.selectedData[0] && 
                            this.props.state.selectedData[0].call_histories 
            ? this.props.state.selectedData[0].call_histories 
            : [];
        
        // ★追加: ローディング状態の表示 (#200)
        const loadingMessage = this.props.state.loadingCallHistories 
            ? "通話履歴を読み込み中..." 
            : null;
        
        return(
            <InlineForm
                key = "call_history_detail"
                controlId = "call_history_detail"   
                label = {`${this.props.langText.Body.CallHistory} (${this.props.state.call_histories_total_count}${this.props.langText.Body.Count})${loadingMessage ? ' - ' + loadingMessage : ''}`}>
                <CommonTable
                    className = "none-overflow"
                    showPagination = {true}
                    defaultPageSize = {5}
                    autoResetPage = {false}
                    langText = {this.props.langText.Table}
                    columns = {[{
                        Header :this.props.langText.Body.Number,
                        accessor: "dest_tel_number",
                        width: 120, // ★追加: 列幅調整 (#142)
                    },
                    {
                        Header: this.props.langText.Body.CallOverview,
                        accessor: "awt062_call_history_detail.analysis_data_overview",
                        minWidth: 200, // ★追加: 列幅調整 (#142)
                    },
                    {
                        Header: this.props.langText.Body.CallDate,
                        accessor: "answer_datetime",
                        width: 150, // ★追加: 列幅調整 (#142)
                        Cell: data => {
                            if (data.row.original.answer_datetime) {
                                let elemArr = [];
                                let answer_datetime = data.row.original.answer_datetime;
                                elemArr.push( 
                                    <p key={"call_start_date"} className="call-history-date">
                                        {moment(answer_datetime).local().format("YYYY/MM/DD")}
                                    </p>
                                );
                                elemArr.push( 
                                    <p key={"call_start_time"} className="call-history-date">
                                        {moment(answer_datetime).local().format("HH:mm:ss")}
                                    </p>
                                );
                                elemArr.push( 
                                    <p key={"call_time_ago"} className="call-history-date">
                                        {`(${this.props.getTimeAgo(answer_datetime)})`}
                                    </p>
                                );
                                return (elemArr);
                            } else {
                                return "---";
                            }
                        }
                    },
                    {
                        Header: this.props.langText.Body.CallCategory,
                        accessor: "categories",
                        width: 150, // ★追加: 列幅調整 (#142)
                        Cell: data => {
                            if (data.row.original.awt062_call_history_detail && data.row.original.awt062_call_history_detail.awt018_categories) {
                                let categories = data.row.original.awt062_call_history_detail.awt018_categories;
                                if (!Array.isArray(categories)) {
                                    categories = [categories];
                                }
                                return categories.map((row, index) => {
                                    return (
                                        <span
                                            key={index}
                                            className="call-category-tag"
                                            style={{
                                                backgroundColor: row.rgb,
                                                color: row.font_rgb
                                            }}
                                        >
                                            {row.name}
                                        </span>
                                    );
                                });
                            } else {
                                return "";
                            }
                        }
                    },
                    // ★追加: 音声再生ボタン (#142)
                    {
                        Header: this.props.langText.Body.Control,
                        accessor: "playback",
                        width: 80, // ★追加: 列幅調整 (#142)
                        Cell: data => {
                            // ht60_recorded_voices.idが存在する場合のみ再生ボタンを表示
                            if (data.row.original.id) {
                                // ★追加: 削除済み録音の場合はマイナスアイコンを表示 (#142)
                                if (data.row.original.voice_del_flag === "Y") {
                                    let speechBubbleData = [];
                                    if (data.row.original.voice_deleted) {
                                        speechBubbleData.push(<div key={data.row.original.id + "_deleted_date"}>{moment(data.row.original.voice_deleted).utc()
                                            .add(9, "h").format("YYYY/MM/DD HH:mm")}</div>);
                                    }
                                    if (data.row.original.voice_deleted_user_id) {
                                        speechBubbleData.push(<div key={data.row.original.id + "_deleted_user"}>{data.row.original.voice_deleted_user_id
                                            + " " + (this.props.langText.Message.Record_VoiceDeleted || "が削除しました")}</div>)
                                    }
                                    return (
                                        <ButtonSpeechBubble
                                            key={data.row.original.id + "_voice_deleted"}
                                            size="sm"
                                            className="control-button-disabled"
                                            DisplayIcon={faMinus}
                                            speechBubble={speechBubbleData}
                                        />
                                    );
                                }
                                // 削除されていない場合は通常の再生ボタン
                                return this.props.onPlayAudio ? (
                                    <ButtonSpeechBubble
                                        key={data.row.original.id + "_playback"}
                                        size="sm"
                                        onClick={() => this.props.onPlayAudio(data.row.original)}
                                        className="control-button"
                                        DisplayIcon={faPlay}
                                        speechBubble={[
                                            <div key={data.row.original.id + "_PlayBack"}>
                                                {this.props.langText.Body.PlayBack || '録音再生'}
                                            </div>
                                        ]}
                                    />
                                ) : null;
                            }
                            return "---";
                        }
                    }]}
                    data = {callHistories}
                />
            </InlineForm>
        );
    }
}

/**
 * 
 * 削除項目ビューアイテム
 * state.selectedDataが必要
 */
export class ViewPhoneBookList extends Component {
    render(){
        return(
            <InlineForm
                key = "phonebook_detail"
                controlId = "phonebook_detail">
                <CommonTable
                    className = "none-overflow"
                    showPagination = {true}
                    defaultPageSize = {10}
                    langText = {this.props.langText.Table}
                    columns = {[{
                        Header :this.props.langText.Body.PhoneBookId,
                        accessor: "id",
                    },
                    {
                        Header :this.props.langText.Body.Name,
                        accessor: "name",
                    }]}
                    data = {this.props.state.selectedData}
                />
            </InlineForm>
        );
    }
}